import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  ICompanyDocument,
  ICompanyDocumentResponse,
} from 'src/Types/module/member/CompanyInformation';
import ModalsWrapper from 'src/components/Modals/ModalsWrapper';
import OrganizatonOtherinput from '../../../CompanyAddInfo/CompanyAddInfoComponents/OrganizatonOtherinput';
import GlobalLoader from 'src/components/SuspenseLoader/GlobalLoader';
import UpdateCompanyDocument from '../../../CompanyAddInfo/UpdateCompanyInformation/UpdateCompanyDocument';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import PageTitle from 'src/components/PageTitle';
import { HttpClient } from 'src/Helpers/http/http';
import PdfAndImageView from 'src/components/pdfAndImageView/PdfAndImageView';
import { CommonTypoGraphy } from 'src/components/pdfAndImageView/CommonTypoGraphy';
import moment from 'moment';
import AdditionalDocuments from './AdditionalDocuments';

function CompanyDocumentInfo() {
  const { memberId } = useParams();
  const [open, setOpen] = useState<boolean>(false);
  const [companyDocument, setCompanyDocument] = useState<ICompanyDocument>(
    {} as ICompanyDocument
  );
  const [refresh, setRefresh] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const [imageViewOpen, SetImageViewOpen] = useState<boolean>(false);
  const [imageFile, setImageFile] = useState<string | null>('');

  useEffect(() => {
    setLoading(true);
    (async function () {
      try {
        const data: ICompanyDocumentResponse = await HttpClient.get(
          `/api/atab/admin/member-company/member/docs-trade-aviation/${memberId}`
        );
        if (data.success) {
          setCompanyDocument(data.data);
          setLoading(false);
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      }
    })();
  }, [memberId, refresh]);

  const { companyCivilAviation, companyDocs, companyLicense } =
    companyDocument || {};

  const {
    company_bin_file,
    company_bin_number,
    company_tin_file,
    company_tin_number,
    company_trade_license,
    company_trade_license_file,
    company_trade_license_expiry_date,
  } = companyLicense || {};

  const {
    certificate_expiry_date,
    certificate_file,
    certificate_issue_date,
    certificate_number,
  } = companyCivilAviation || {};

  return (
    <>
      <>
        <PageTitleWrapper>
          <PageTitle
            heading='Company Document'
            actionButtonTitle={
              companyDocs?.company_ownership_status ? 'Update' : 'Add'
            }
            setAction={setOpen}
          />
        </PageTitleWrapper>
        {loading ? (
          <GlobalLoader />
        ) : (
          <>
            {companyDocs?.company_ownership_status ? (
              <Grid sx={{ pb: 5 }} container spacing={2}>
                <Grid item xs={12} md={6}>
                  <TableContainer component={Paper}>
                    <Table aria-label='custom pagination table'>
                      <TableBody>
                        <TableRow>
                          <TableCell component='th' scope='row'>
                            Ownership status:
                          </TableCell>
                          <TableCell align='right'>
                            {companyDocs?.company_ownership_status
                              ? companyDocs?.company_ownership_status
                              : 'Not provided'}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell component='th' scope='row'>
                            View Incorporation Certificate:
                          </TableCell>
                          <TableCell align='right'>
                            {companyDocs?.company_incorporation_certificate ? (
                              <CommonTypoGraphy
                                name='View'
                                onClick={() => {
                                  SetImageViewOpen(true);
                                  setImageFile(
                                    companyDocs?.company_incorporation_certificate
                                  );
                                }}
                              />
                            ) : (
                              'Not provided'
                            )}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell component='th' scope='row'>
                            View Staff list:
                          </TableCell>
                          <TableCell align='right'>
                            {companyDocs?.company_staff_list_file ? (
                              <CommonTypoGraphy
                                name='View'
                                onClick={() => {
                                  SetImageViewOpen(true);
                                  setImageFile(
                                    companyDocs?.company_staff_list_file
                                  );
                                }}
                              />
                            ) : (
                              'Not provided'
                            )}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell component='th' scope='row'>
                            Office agreement:
                          </TableCell>
                          <TableCell align='right'>
                            {companyDocs?.company_office_agreement
                              ? companyDocs?.company_office_agreement
                              : 'Not provided'}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell component='th' scope='row'>
                            View Agreement file:
                          </TableCell>
                          <TableCell align='right'>
                            {companyDocs?.company_agreement_file ? (
                              <CommonTypoGraphy
                                name='View'
                                onClick={() => {
                                  SetImageViewOpen(true);
                                  setImageFile(
                                    companyDocs?.company_agreement_file
                                  );
                                }}
                              />
                            ) : (
                              'Not provided'
                            )}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell component='th' scope='row'>
                            Partnership deed file:
                          </TableCell>
                          <TableCell align='right'>
                            {companyDocs?.company_partnership_deed_file ? (
                              <CommonTypoGraphy
                                name='View'
                                onClick={() => {
                                  SetImageViewOpen(true);
                                  setImageFile(
                                    companyDocs?.company_partnership_deed_file
                                  );
                                }}
                              />
                            ) : (
                              'Not provided'
                            )}
                          </TableCell>
                        </TableRow>
                        {companyDocs?.company_office_photographs?.length ? (
                          <>
                            {companyDocs?.company_office_photographs?.map(
                              (img, index) => {
                                return (
                                  <TableRow key={index}>
                                    <TableCell component='th' scope='row'>
                                      {`Office photographs ${index + 1}`}:
                                    </TableCell>
                                    <TableCell align='right'>
                                      <ul>
                                        {companyDocs?.company_office_photographs
                                          ?.length ? (
                                          <>
                                            <li
                                              key={index}
                                              style={{
                                                listStyle: 'none',
                                              }}
                                            >
                                              <CommonTypoGraphy
                                                name='View'
                                                onClick={() => {
                                                  SetImageViewOpen(true);
                                                  setImageFile(img);
                                                }}
                                              />
                                            </li>
                                          </>
                                        ) : (
                                          'Not provided'
                                        )}
                                      </ul>
                                    </TableCell>
                                  </TableRow>
                                  // <li
                                  //   key={index}
                                  //   style={{
                                  //     listStyle: 'none',
                                  //   }}
                                  // >
                                  //   <CommonTypoGraphy
                                  //     name='View'
                                  //     onClick={() => {
                                  //       SetImageViewOpen(true);
                                  //       setImageFile(img);
                                  //     }}
                                  //   />
                                  // </li>
                                );
                              }
                            )}
                          </>
                        ) : (
                          'Not provided'
                        )}{' '}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TableContainer component={Paper}>
                    <Table aria-label='custom pagination table'>
                      <TableBody>
                        <TableRow>
                          <TableCell component='th' scope='row'>
                            Memorandum file:
                          </TableCell>
                          <TableCell align='right'>
                            {companyDocs?.company_memorandum_file ? (
                              <CommonTypoGraphy
                                name='View'
                                onClick={() => {
                                  SetImageViewOpen(true);
                                  setImageFile(
                                    companyDocs?.company_memorandum_file
                                  );
                                }}
                              />
                            ) : (
                              'Not provided'
                            )}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell component='th' scope='row'>
                            One staff GDS certificate:
                          </TableCell>
                          <TableCell align='right'>
                            {companyDocs?.company_one_staff_certificate ? (
                              <CommonTypoGraphy
                                name='View'
                                onClick={() => {
                                  SetImageViewOpen(true);
                                  setImageFile(
                                    companyDocs?.company_one_staff_certificate
                                  );
                                }}
                              />
                            ) : (
                              'Not provided'
                            )}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell component='th' scope='row'>
                            Bank statement:
                          </TableCell>
                          <TableCell align='right'>
                            {companyDocs?.company_bank_statement ? (
                              <CommonTypoGraphy
                                name='View'
                                onClick={() => {
                                  SetImageViewOpen(true);
                                  setImageFile(
                                    companyDocs?.company_bank_statement
                                  );
                                }}
                              />
                            ) : (
                              'Not provided'
                            )}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell component='th' scope='row'>
                            Sales statement:
                          </TableCell>
                          <TableCell align='right'>
                            {companyDocs?.company_sales_statement ? (
                              <CommonTypoGraphy
                                name='View'
                                onClick={() => {
                                  SetImageViewOpen(true);
                                  setImageFile(
                                    companyDocs?.company_sales_statement
                                  );
                                }}
                              />
                            ) : (
                              'Not provided'
                            )}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell component='th' scope='row'>
                            Undertaking File:
                          </TableCell>
                          <TableCell align='right'>
                            {companyDocs?.company_undertaking_file ? (
                              <CommonTypoGraphy
                                name='View'
                                onClick={() => {
                                  SetImageViewOpen(true);
                                  setImageFile(
                                    companyDocs?.company_undertaking_file
                                  );
                                }}
                              />
                            ) : (
                              'Not provided'
                            )}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </Grid>
            ) : (
              <Typography
                variant='h3'
                gutterBottom
                sx={{ textAlign: 'center' }}
              >
                No data found
              </Typography>
            )}
          </>
        )}
      </>

      <>
        {company_trade_license ? (
          <Grid sx={{ pb: 5 }} container spacing={2}>
            <Grid item xs={12} md={6}>
              <TableContainer component={Paper}>
                <Table aria-label='custom pagination table'>
                  <TableBody>
                    <TableRow>
                      <TableCell component='th' scope='row'>
                        Trade license:
                      </TableCell>
                      <TableCell align='right'>
                        {company_trade_license
                          ? company_trade_license
                          : 'Not provided'}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component='th' scope='row'>
                        Trade license file:
                      </TableCell>
                      <TableCell align='right'>
                        {company_trade_license_file ? (
                          <CommonTypoGraphy
                            name='View'
                            onClick={() => {
                              SetImageViewOpen(true);
                              setImageFile(company_trade_license_file);
                            }}
                          />
                        ) : (
                          'Not provided'
                        )}
                      </TableCell>
                    </TableRow>

                    {/* Need actual key of field */}
                    <TableRow>
                      <TableCell component='th' scope='row'>
                        Trade license expiry date:
                      </TableCell>
                      <TableCell align='right'>
                        {company_trade_license_expiry_date
                          ? moment(company_trade_license_expiry_date)?.format(
                            'Do MMM YYYY'
                          )
                          : 'Not provided'}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component='th' scope='row'>
                        TIN number:
                      </TableCell>
                      <TableCell align='right'>
                        {company_tin_number
                          ? company_tin_number
                          : 'Not provided'}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid item xs={12} md={6}>
              <TableContainer component={Paper}>
                <Table aria-label='custom pagination table'>
                  <TableBody>
                    <TableRow>
                      <TableCell component='th' scope='row'>
                        Proof of Submission of Tax Return (Acknowledgement
                        Receipt)
                      </TableCell>
                      <TableCell align='right'>
                        {company_tin_file ? (
                          <CommonTypoGraphy
                            name='View'
                            onClick={() => {
                              SetImageViewOpen(true);
                              setImageFile(company_tin_file);
                            }}
                          />
                        ) : (
                          'Not provided'
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component='th' scope='row'>
                        Company BIN number:
                      </TableCell>
                      <TableCell align='right'>
                        {company_bin_number
                          ? company_bin_number
                          : 'Not provided'}{' '}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component='th' scope='row'>
                        Company BIN file:
                      </TableCell>
                      <TableCell align='right'>
                        {company_bin_file ? (
                          <CommonTypoGraphy
                            name='View'
                            onClick={() => {
                              SetImageViewOpen(true);
                              setImageFile(company_bin_file);
                            }}
                          />
                        ) : (
                          'Not provided'
                        )}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        ) : (
          <Typography variant='h3' gutterBottom sx={{ textAlign: 'center' }}>
            No data found
          </Typography>
        )}
      </>

      <>
        {certificate_number || certificate_file ? (
          <Grid sx={{ pb: 5 }} container spacing={2}>
            <Grid item xs={12} md={6}>
              <TableContainer component={Paper}>
                <Table aria-label='custom pagination table'>
                  <TableBody>
                    <TableRow>
                      <TableCell component='th' scope='row'>
                        Certificate number:
                      </TableCell>
                      <TableCell align='right'>
                        {certificate_number
                          ? certificate_number
                          : 'Not provided'}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component='th' scope='row'>
                        Certificate issue date:
                      </TableCell>
                      <TableCell align='right'>
                        {certificate_issue_date
                          ? moment(certificate_issue_date).format('Do MMM YYYY')
                          : 'Not provided'}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid item xs={12} md={6}>
              <TableContainer component={Paper}>
                <Table aria-label='custom pagination table'>
                  <TableBody>
                    <TableRow>
                      <TableCell component='th' scope='row'>
                        Certificate expiry date:
                      </TableCell>
                      <TableCell align='right'>
                        {certificate_expiry_date
                          ? moment(certificate_expiry_date).format(
                            'Do MMM YYYY'
                          )
                          : 'Not provided'}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component='th' scope='row'>
                        Civil aviation certificate :
                      </TableCell>
                      <TableCell align='right'>
                        {certificate_file ? (
                          <CommonTypoGraphy
                            name='View'
                            onClick={() => {
                              SetImageViewOpen(true);
                              setImageFile(certificate_file);
                            }}
                          />
                        ) : (
                          'Not provided'
                        )}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        ) : (
          <Typography variant='h3' gutterBottom sx={{ textAlign: 'center' }}>
            No data found
          </Typography>
        )}
      </>

      {memberId && <AdditionalDocuments memberId={memberId} />}

      <ModalsWrapper
        setShowModal={setOpen}
        showModal={open}
        modalData={{
          title: companyDocs?.company_ownership_status
            ? 'Update company document'
            : 'Add company document',
        }}
      >
        {companyDocs?.company_ownership_status ? (
          <UpdateCompanyDocument
            memberId={memberId}
            companyDocument={companyDocument}
            setRefresh={setRefresh}
            setOpen={setOpen}
            refresh={refresh}
          />
        ) : (
          <OrganizatonOtherinput
            memberId={memberId}
            setRefresh={setRefresh}
            setOpen={setOpen}
            refresh={refresh}
          />
        )}
      </ModalsWrapper>

      <PdfAndImageView
        setOpen={SetImageViewOpen}
        open={imageViewOpen}
        file={imageFile}
      />
    </>
  );
}

export default CompanyDocumentInfo;
